// import React from 'react';
import Atoms from '../Atoms';

import './Molecules.scss';
import ToggleButton from './ToggleButton';
import ExpandMenu from './ExpandMenu';
import FloatButton from './Float_Button';

// export const Molecules = () => {
//     return (
//         <div>
//             <h2>From Molecules</h2>
//             <Atoms.Button 
//                 className='eb-button-new'
//                 id='ebButtonNew'
//                 value = 'Molecules'
//             />
//             <ToggleButton
//                 childId = 'toggle_test'
//                 id = 'toggleTestContainer'
//             />
//             <ExpandMenu />
//             <FloatButton />
//         </div>
//     )
// }

let Molecules = {
    Atoms,
    ExpandMenu,
    FloatButton,
    ToggleButton
}

export default Molecules;